import { NavigationPath } from './navigation-path';
import Screens from '@/screens';
import { Route } from '@/router/router-types';

export const publicRoutes: Route[] = [
	{
		path: NavigationPath.createAccount,
		element: <Screens.CreateAccountScreen />
	},
	{
		path: NavigationPath.login,
		element: <Screens.LoginScreen />
	},
	{
		path: NavigationPath.landingPage,
		element: <Screens.Landing />
	},
	{
		path: NavigationPath.deleteAccount,
		element: <Screens.DeleteAccountScreen />
	}
];
